import(/* webpackMode: "eager" */ "/root/edocai/edocai/app/[lang]/loading.tsx");
